import React, { useEffect, useState, useCallback } from 'react';
import Layout from '../components/Layout';
import { API } from '../api';
import { toast, ToastContainer } from 'react-toastify';

export default function Stopsale() {

    const formatDate = (date) => {
        if (!date) return '';
        const d = new Date(date);
        return d.getFullYear() + '-' +
          String(d.getMonth() + 1).padStart(2, '0') + '-' +
          String(d.getDate()).padStart(2, '0');
      };

  const [data, setData] = useState([]);
  const [groups, setGroups] = useState([]);
  const [cars, setCars] = useState([]);

  const [search, setSearch] = useState('');
  const [filterGroup, setFilterGroup] = useState(0);

  const [modalOpen, setModalOpen] = useState(false);
  const [form, setForm] = useState({
    group_id: '',
    car_id: '',
    from_date: '',
    to_date: ''
  });

  const [editId, setEditId] = useState(null);

  // Fetch data
  const fetchData = useCallback(() => {
    API.get('/stopsale', { params: { search, group_id: filterGroup } })
      .then(res => setData(res.data.data))
      .catch(() => toast.error('Failed to load data'));
  }, [search, filterGroup]);

  useEffect(() => { fetchData(); }, [search, filterGroup]);

  useEffect(() => {
    API.get('/cargroup').then(r => setGroups(r.data.data));
    API.get('/cars').then(r => setCars(r.data.data));
  }, []);

  // Submit
  const handleSubmit = async () => {
    try {
      if (editId) {
        await API.put(`/stopsale/${editId}`, form);
        toast.success('Updated successfully');
      } else {
        await API.post('/stopsale', form);
        toast.success('Added successfully');
      }
      setModalOpen(false);
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error');
    }
  };

  // Delete
  const handleDelete = async (id) => {
    if (!window.confirm('Delete this record?')) return;
    await API.delete(`/stopsale/${id}`);
    toast.success('Deleted');
    fetchData();
  };

  return (
    <Layout activePage="Stop Sale">
      <ToastContainer />

      {/* Header */}
      <div style={S.topbar}>
        <div>
          <h2 style={S.title}>Stop Sale Management</h2>
          <p style={S.subtitle}>Manage stop sale dates for vehicles</p>
        </div>
        <button style={S.addBtn} onClick={() => {
          setForm({ group_id: '', car_id: '', from_date: '', to_date: '' });
          setEditId(null);
          setModalOpen(true);
        }}>
          + Add Stop Sale
        </button>
      </div>

      {/* Filters */}
      <div style={S.filterRow}>
        <div style={S.searchWrap}>
          🔍
          <input
            placeholder="Search car..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={S.searchInput}
          />
        </div>

        <select
          value={filterGroup}
          onChange={e => setFilterGroup(e.target.value)}
          style={S.filterSelect}
        >
          <option value={0}>— All Groups —</option>
          {groups.map(g => (
            <option key={g.group_id} value={g.group_id}>{g.group_name}</option>
          ))}
        </select>
      </div>

      {/* Table Card */}
      <div style={S.card}>
        <table style={S.table}>
          <thead>
            <tr style={S.theadRow}>
              <th style={S.th}>#</th>
              <th style={S.th}>Group</th>
              <th style={S.th}>Car</th>
              <th style={S.th}>From</th>
              <th style={S.th}>To</th>
              <th style={S.th}>Action</th>
            </tr>
          </thead>

          <tbody>
            {data.length === 0 ? (
              <tr><td colSpan="6" style={S.emptyCell}>No records found</td></tr>
            ) : data.map((row, i) => (
              <tr key={row.stopsale_id}>
                <td style={S.td}>{i + 1}</td>
                <td style={S.td}><span style={S.groupChip}>{row.group_name}</span></td>
                <td style={S.td}><span style={S.nameChip}>{row.car_name}</span></td>
                <td style={S.td}>{formatDate(row.stopsale_frmdt)}</td>
                <td style={S.td}>{formatDate(row.stopsale_todt)}</td>
                <td style={S.td}>
                <button style={S.editBtn} onClick={() => {
                setForm({
                group_id: row.group_id || '',
                car_id: row.car_id || '',
                from_date: formatDate(row.stopsale_frmdt),
                to_date: formatDate(row.stopsale_todt)
                });
                setEditId(row.stopsale_id);
                setModalOpen(true);
                }}>Edit</button>

                  <button style={S.delBtn} onClick={() => handleDelete(row.stopsale_id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {modalOpen && (
  <div style={S.overlay} onClick={() => setModalOpen(false)}>
    <div style={S.modalBox} onClick={e => e.stopPropagation()}>

      {/* Header */}
      <div style={S.modalHead}>
        <h3 style={{ margin: 0 }}>
          {editId ? '✏️ Edit Stop Sale' : '➕ Add Stop Sale'}
        </h3>
        <button style={S.closeBtn} onClick={() => setModalOpen(false)}>✕</button>
      </div>

      {/* Body */}
      <div style={S.modalBody}>

        <div style={S.fg}>
          <label style={S.label}>Car Group</label>
          <select
            value={form.group_id}
            onChange={e => setForm({ ...form, group_id: e.target.value })}
            style={S.input}
          >
            <option value="">Select Group</option>
            {groups.map(g => (
              <option key={g.group_id} value={g.group_id}>
                {g.group_name}
              </option>
            ))}
          </select>
        </div>

        <div style={S.fg}>
          <label style={S.label}>Car</label>
            <select disabled={!form.group_id}
            value={form.car_id}
            onChange={e => setForm({ ...form, car_id: e.target.value })}
            style={S.input}
            >
            <option value="">Select Car</option>

            {cars
            .filter(c => c.group_id == form.group_id)   // ✅ FILTER HERE
            .map(c => (
            <option key={c.car_id} value={c.car_id}>
            {c.car_name}
            </option>
            ))
            }
            </select>
        </div>

        <div style={S.grid2}>
          <div style={S.fg}>
            <label style={S.label}>From Date</label>
            <input
              type="date"
              value={form.from_date}
              onChange={e => setForm({ ...form, from_date: e.target.value })}
              style={S.input}
            />
          </div>

          <div style={S.fg}>
            <label style={S.label}>To Date</label>
            <input
              type="date"
              value={form.to_date}
              onChange={e => setForm({ ...form, to_date: e.target.value })}
              style={S.input}
            />
          </div>
        </div>

      </div>

      {/* Footer */}
      <div style={S.modalFoot}>
        <button style={S.cancelBtn} onClick={() => setModalOpen(false)}>
          Cancel
        </button>

        <button style={S.submitBtn} onClick={handleSubmit}>
          {editId ? 'Update' : 'Save'}
        </button>
      </div>

    </div>
  </div>
)}

    </Layout>
  );
}


/* ─── Styles ─── */
const S = {
    root: { display: 'flex', minHeight: '100vh', background: '#f4f6fb', fontFamily: "'DM Sans','Segoe UI',sans-serif" },
  
    /* Sidebar */
  //   sidebar: { background: '#1a1d2e', color: '#fff', display: 'flex', flexDirection: 'column',
  //     position: 'fixed', height: '100vh', transition: 'width 0.25s', overflow: 'hidden', zIndex: 100 },
  //   sideTop: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '20px 16px 16px' },
  //   logoWrap: { display: 'flex', alignItems: 'center', gap: 10 },
  //   logoIcon: { width: 36, height: 36, background: 'linear-gradient(135deg,#6C63FF,#43BCCD)',
  //     borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, flexShrink: 0 },
  //   logoText: { fontSize: 18, fontWeight: 800, letterSpacing: '-0.5px', whiteSpace: 'nowrap' },
  //   collapseBtn: { background: 'rgba(255,255,255,0.08)', border: 'none', color: '#aaa',
  //     borderRadius: 6, padding: '4px 8px', cursor: 'pointer', fontSize: 11, flexShrink: 0 },
  //   navItem: { display: 'flex', alignItems: 'center', gap: 12,
  //     paddingTop: '11px', paddingBottom: '11px', paddingLeft: '16px', paddingRight: '16px',
  //     cursor: 'pointer', borderRadius: 10, margin: '2px 10px',
  //     color: '#aaa', fontSize: 14, transition: 'all 0.15s', whiteSpace: 'nowrap' },
  //   navActive: { background: 'rgba(99,179,237,0.12)', color: '#63b3ed',
  //     borderLeft: '3px solid #63b3ed', paddingLeft: '13px' },
  //   navIcon: { fontSize: 16, flexShrink: 0 },
  //   navLabel: { fontWeight: 500 },
  //   sideBottom: { padding: '16px', borderTop: '1px solid rgba(255,255,255,0.07)' },
  //   userChip: { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 },
  //   avatar: { width: 36, height: 36, background: 'linear-gradient(135deg,#6C63FF,#43BCCD)',
  //     borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
  //     fontWeight: 800, fontSize: 15, flexShrink: 0 },
  //   userName: { fontSize: 13, fontWeight: 700, color: '#fff' },
  //   userRole: { fontSize: 11, color: '#777' },
  //   logoutBtn: { width: '100%', background: 'rgba(255,100,100,0.12)', border: '1px solid rgba(255,100,100,0.2)',
  //     color: '#ff6b6b', borderRadius: 8, padding: '8px 12px', cursor: 'pointer', fontSize: 13,
  //     display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'inherit' },
  
    /* Main */
    main: { flex: 1, padding: '28px 28px 40px', minWidth: 0, transition: 'margin-left 0.25s' },
    topbar: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 },
    title: { margin: 0, fontSize: 26, fontWeight: 800, color: '#1a1d2e', letterSpacing: '-0.5px' },
    subtitle: { margin: '4px 0 0', fontSize: 13, color: '#999' },
    addBtn: { padding: '10px 22px', background: 'linear-gradient(135deg,#6C63FF,#43BCCD)',
      color: '#fff', border: 'none', borderRadius: 10, cursor: 'pointer',
      fontSize: 14, fontWeight: 700, fontFamily: 'inherit', boxShadow: '0 4px 14px rgba(108,99,255,0.35)' },
  
    /* Filters */
    filterRow: { display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap' },
    searchWrap: { display: 'flex', alignItems: 'center', gap: 8, background: '#fff',
      border: '1px solid #e8e8e8', borderRadius: 10, padding: '8px 14px',
      flex: 1, minWidth: 220, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' },
    searchInput: { border: 'none', outline: 'none', fontSize: 13, flex: 1,
      fontFamily: 'inherit', color: '#333', background: 'transparent' },
    clearBtn: { background: 'none', border: 'none', cursor: 'pointer', color: '#aaa', fontSize: 12, padding: 0 },
    filterSelect: { padding: '9px 14px', border: '1.5px solid #e0e0e0', borderRadius: 10,
      fontSize: 13, fontFamily: 'inherit', color: '#333', outline: 'none',
      background: '#fff', minWidth: 180 },
  
    /* Card + Table */
    card: { background: '#fff', borderRadius: 16, boxShadow: '0 2px 16px rgba(0,0,0,0.06)', overflow: 'hidden' },
    table: { width: '100%', borderCollapse: 'collapse' },
    theadRow: { background: '#fafafa' },
    th: { padding: '12px 14px', fontSize: 11, fontWeight: 700, color: '#999',
      textAlign: 'center', borderBottom: '2px solid #f0f0f0',
      textTransform: 'uppercase', letterSpacing: '0.5px' },
    tr: { transition: 'background 0.12s' },
    td: { padding: '12px 14px', fontSize: 13, color: '#333', borderBottom: '1px solid #f8f8f8', textAlign: 'center' },
    emptyCell: { textAlign: 'center', padding: 40, color: '#bbb', fontSize: 14 },
    noImg: { width: 60, height: 40, background: '#f3f2ff', borderRadius: 6,
      display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20 },
  
    /* Chips */
    serial:     { background: '#f3f2ff', color: '#6C63FF', borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 700 },
    nameChip:   { background: '#f0fff6', color: '#1a9e5c', borderRadius: 20, padding: '4px 12px', fontSize: 12, fontWeight: 600 },
    groupChip:  { background: '#f0f8ff', color: '#1a6eb5', borderRadius: 20, padding: '4px 12px', fontSize: 12, fontWeight: 600 },
    stockChip:  { background: '#fff3f0', color: '#d45700', borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 700 },
    badge:      { borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 600 },
  
    /* Action buttons */
    viewBtn: { marginRight: 5, background: '#f0fff6', color: '#1a9e5c',
      border: '1px solid #b8f0d0', padding: '4px 12px',
      borderRadius: 20, cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'inherit' },
    editBtn: { marginRight: 5, background: '#f3f2ff', color: '#6C63FF',
      border: '1px solid #d4d0ff', padding: '4px 12px',
      borderRadius: 20, cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'inherit' },
    delBtn: { background: '#fff2f5', color: '#FF6584', border: '1px solid #ffd0d8',
      padding: '4px 12px', borderRadius: 20, cursor: 'pointer',
      fontSize: 12, fontWeight: 700, fontFamily: 'inherit' },
  
    /* Pagination */
    pagination: { display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      padding: '14px 20px', borderTop: '1px solid #f0f0f0' },
    paginInfo: { fontSize: 12, color: '#999' },
    pgBtn: { padding: '5px 14px', background: '#f3f2ff', color: '#6C63FF',
      border: '1px solid #d4d0ff', borderRadius: 8, cursor: 'pointer',
      fontSize: 12, fontWeight: 600, fontFamily: 'inherit' },
  
    /* Modal */
    overlay: { position: 'fixed', inset: 0, background: 'rgba(10,10,30,0.55)', zIndex: 999,
      display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(2px)' },
    modalBox: { background: '#fff', borderRadius: 20, width: 740, maxWidth: '96vw', maxHeight: '90vh',
      display: 'flex', flexDirection: 'column', boxShadow: '0 24px 60px rgba(0,0,0,0.2)' },
    modalHead: { display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      padding: '18px 22px', borderBottom: '1px solid #f0f0f0', flexShrink: 0 },
    modalBody: { padding: '20px 22px', overflowY: 'auto', flex: 1 },
    modalFoot: { display: 'flex', justifyContent: 'flex-end', gap: 10,
      padding: '14px 22px', borderTop: '1px solid #f0f0f0', flexShrink: 0 },
    closeBtn: { background: '#ff6b6b22', border: 'none', color: '#ff6b6b',
      borderRadius: '50%', width: 30, height: 30, cursor: 'pointer', fontWeight: 800, fontSize: 14 },
    cancelBtn: { padding: '9px 20px', background: '#f5f5f5', color: '#666',
      border: 'none', borderRadius: 10, cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'inherit' },
    submitBtn: { padding: '9px 22px', background: 'linear-gradient(135deg,#6C63FF,#43BCCD)',
      color: '#fff', border: 'none', borderRadius: 10, cursor: 'pointer',
      fontSize: 13, fontWeight: 700, fontFamily: 'inherit' },
  
    /* Form */
    section: { fontSize: 11, fontWeight: 800, color: '#6C63FF', textTransform: 'uppercase',
      letterSpacing: '0.8px', margin: '18px 0 10px', paddingBottom: 6,
      borderBottom: '1.5px solid #f3f2ff' },
    grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 },
    grid4: { display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 12, marginBottom: 14 },
    fg: { display: 'flex', flexDirection: 'column', gap: 5 },
    label: { fontSize: 12, fontWeight: 600, color: '#555' },
    req: { color: '#ff6b6b' },
    input: { padding: '8px 12px', border: '1.5px solid #e0e0e0', borderRadius: 8,
      fontSize: 13, fontFamily: 'inherit', color: '#333', outline: 'none', width: '100%',
      boxSizing: 'border-box' },
  };
  